<div class="modal inmodal fade in" [ngClass]="{'show': showModal}">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">History of Incident Report ID: {{incidentReportsService.historyModalIncidentReport.incidentReportNumber}}</h4>
            </div>
            <div class="modal-body">
                <div class="timeline">
                    <spinner [spinnerShow]="!activities.length"></spinner>
                    <ul class="timeline__list">
                        <li *ngFor="let a of activities">
                            <section *ngIf="a.action !== 'ignore'">
                                <header class="timeline__header">
                                    <span>
                                        <time>{{ a.loggedAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.userFullName }}
                                    </span>
                                </header>

                                <main class="timeline__content">
                                    <div [ngSwitch]="a.action">
                                        <ng-template [ngSwitchCase]="'update'">
                                            {{ a.activityType }}
                                            <span class="timeline__active">"{{a.name}}"</span>
                                            <ul class="field-changes">
                                                <li *ngFor="let item of a.data">
                                                    {{ item?.key }} :
                                                    <span class="timeline__active">"{{ item?.old }}"</span>
                                                    changed to
                                                    <span class="timeline__active">"{{ item?.new }}"</span>
                                                </li>
                                            </ul>
                                        </ng-template>

                                        <ng-template [ngSwitchCase]="'create'">
                                            <p>
                                                {{ a.activityType }}
                                                <span class="timeline__active">"{{a.name}}"</span>
                                                was received
                                            </p>

                                            <ul class="field-changes">
                                                <li *ngFor="let item of a.data">
                                                    {{ item.key }} :
                                                    <span class="timeline__active">{{ item.value }}</span>
                                                </li>
                                            </ul>
                                        </ng-template>
                                    </div>
                                </main>
                            </section>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-report-history-modal/incident-report-history-modal.component.html